import { HamburgerIcon } from '@chakra-ui/icons';
import { Center, Flex, Heading, IconButton, Menu, MenuButton, MenuItem, MenuList, Square } from '@chakra-ui/react';
import React from 'react';
import { FaListOl, FaSlidersH } from 'react-icons/fa';
import { useHistory, useLocation } from 'react-router-dom';
import urljoin from 'url-join';
import { removeTrailingSlash } from '../tools/removeTrailingSlash';

const Navigation: React.FC<{ prefix: string }> = ({ prefix }) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <Flex as="nav">
      <Center h="50px" w="50px">
        <Menu>
          <MenuButton as={IconButton} aria-label="Options" icon={<HamburgerIcon />} variant="outline" />

          <MenuList>
            <MenuItem
              icon={<FaListOl />}
              as="div"
              disabled={removeTrailingSlash(location.pathname) === removeTrailingSlash(urljoin(prefix, '/'))}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();

                if (removeTrailingSlash(location.pathname) === removeTrailingSlash(urljoin(prefix, '/'))) {
                  return;
                }

                history.push({ pathname: removeTrailingSlash(urljoin(prefix, '/')) });
              }}
            >
              글자 수 세기
            </MenuItem>

            <MenuItem
              icon={<FaSlidersH />}
              as="div"
              disabled={removeTrailingSlash(location.pathname) === removeTrailingSlash(urljoin(prefix, '/layout'))}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();

                if (removeTrailingSlash(location.pathname) === removeTrailingSlash(urljoin(prefix, '/layout'))) {
                  return;
                }

                history.push({ pathname: removeTrailingSlash(urljoin(prefix, '/layout')) });
              }}
            >
              문장 배열하기
            </MenuItem>
          </MenuList>
        </Menu>
      </Center>

      <Square style={{ marginRight: 35, justifyContent: 'center', flexGrow: 1 }}>
        <Heading as="h1">
          서예 도움: {location.pathname === removeTrailingSlash(urljoin(prefix, '/')) ? '글자 수 세기' : '문장 배열하기'}
        </Heading>
      </Square>
    </Flex>
  );
};

export default Navigation;
